<template>
    <v-card outlined width="100%" class="my-3">
      <v-card-text class="pa-0">
        <v-row class="ma-0">
          <v-col cols="12" sm="12" md="12" class="pa-0" v-if="loaderLoading">
            <v-skeleton-loader
              type="image, image, image"
              width="100%"
              :height="getHeight"
            ></v-skeleton-loader>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="pa-0"
            v-else-if="iframeUrl"
          >
            <iframe
              :title="$t('menu.businessManagement')"
              style="border: none !important"
              width="100%"
              :height="getHeight"
              :src="iframeUrl"
            >
            </iframe>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="pa-0" v-else>
            <v-card flat class="mx-auto" :height="getHeight">
              <v-card-text>
                <p class="text-center">
                  <strong style="color: #404040">
                    {{ $t(errorMsg) }}
                  </strong>
                </p>
                <p class="text-center">
                  <strong>
                    {{ $t("msgContactSupport") }}
                  </strong>
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <Loader :loading="loaderLoading" :message="loaderText"></Loader>
    </v-card>
  </template>
  
  <script>
  import Loader from "@/components/Loader.vue";
  import { mapActions, mapState } from "vuex";
import IRService from '../../api/IRService';
  export default {
    name: "BusinessManagementAnalysis",
    components: {
      Loader,
    },
    data() {
      return {
        loaderLoading: false,
        errorMsg: "",
        iframeUrl: '',
        tenantId: sessionStorage.getItem('tenantId'),
      };
    },
    computed: {
      ...mapState({
        stockDetails: (state) => state.stock.stockDetails,
      }),
      loaderText() {
        return this.$t("LoaderText");
      },
      getHeight() {
        return window.innerHeight - 170;
      },
    },
    async mounted() {
      try {
        this.loaderLoading = true;
        const response = await IRService.getBusinessManagement();
        this.iframeUrl = response.data.replace(/^"(.*)"$/, '$1');
      } catch (error) {
        this.errorMsg = error?.response?.data?.jp_response_key;
        console.error(error);
      } finally {
        this.loaderLoading = false;
      }
    },
  };
  </script>
  
  <style>
  </style>